import React, { useState, useMemo } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Form,
  Dropdown,
} from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Banner from "../../components/Banner";
import BreadcrumbBar from "../../components/Breadcrumb";

export default function AddConversation() {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const { id } = useParams();
  const { state } = useLocation();

  // Safely get the item
  const item = useMemo(() => {
    if (state?.item) return state.item;
    const list = window.__COMMUNITY_RESULTS__ || [];
    return list.find((r) => String(r.id) === String(id)) || {}; // Safely return empty object if not found
  }, [id, state]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can handle form submission logic, such as sending data to a backend
    console.log("Topic Title:", title);
    console.log("Description:", description);
    console.log("Category:", category);
    // Redirect back to the community page or show success message
    navigate("/community");
  };

  return (
    <>
      <Banner
        heading="Start a New Conversation"
        description="Join the community by sharing your ideas and topics."
      />
      <BreadcrumbBar
        items={[
          { label: "Home", href: "/" },
          { label: "Community", href: "/community" },
          { label: item.title || "Add New Conversation" }, // Fallback to "Add New Conversation"
        ]}
      />
      <Container className="list-section">
        <div className="profile-outer-box mb-0 mt-0">
          <Row>
            <Col lg={8} md={10} className="mx-auto">
              <Card>
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label>Topic Title</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="What would you like to discuss?"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={5}
                        placeholder="Write a description.."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label>Choose Category</Form.Label>
                      <Dropdown>
                        <Dropdown.Toggle variant="outline-secondary">
                          {category || "Select a category"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {["Cardiology", "Neurology", "Oncology"].map(
                            (cat, idx) => (
                              <Dropdown.Item
                                key={idx}
                                onClick={() => setCategory(cat)}
                              >
                                {cat}
                              </Dropdown.Item>
                            )
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Form.Group>

                    <Button type="submit" variant="primary">
                      Start a Conversation
                    </Button>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}
